import { render, staticRenderFns } from "./DetailsPermission.vue?vue&type=template&id=0d55e139&scoped=true"
import script from "./DetailsPermission.vue?vue&type=script&lang=js"
export * from "./DetailsPermission.vue?vue&type=script&lang=js"
import style0 from "./DetailsPermission.vue?vue&type=style&index=0&id=0d55e139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d55e139",
  null
  
)

export default component.exports